import classNames from "lib/classNames";
import React from "react"

export default function Bindings ({ only = [], custom = null }) {
    return (
        <div className={classNames("flex flex-wrap items-center text-xs py-1")}>
            You can use
            {Object.entries({
                goal: "goal",
                amount_left: "goal minus total",
                reward: "reward"
            })
                .filter(([key]) => {
                    if (!only.length && !custom) return true;
                    return only.includes(key);
                })
                .concat(custom ? [custom] : [])
                .map(([binding, tooltip], key) => {
                    return (
                        <div className={classNames("relative parent mx-1")} key={key}>
                            <span
                                className={classNames("font-bold text-gray-500 hover:text-blue-500 cursor-pointer")}
                            >{`{{${binding}}}`}</span>
                            <div
                                className={classNames(
                                    "absolute mt-1 bg-black text-white rounded left-0 bottom-full hidden parent-hover:block"
                                )}
                                style={{
                                    width: "max-content"
                                }}
                            >
                                <div className={classNames("relative py-1 px-4")}>
                                    <svg
                                        className={classNames(
                                            "absolute text-black h-2 left-0 ml-3 top-0 transform -translate-y-1/2"
                                        )}
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 255 255"
                                        xmlSpace="preserve"
                                    >
                                        <polygon
                                            className={classNames("fill-current")}
                                            points="0,127.5 127.5,0 255,127.5"
                                        />
                                    </svg>
                                    {tooltip}
                                </div>
                            </div>
                        </div>
                    );
                })}
        </div>
    );
}